import React from 'react'
import { getPNContent, getTnCContent } from '../services/api/requests/TnCAndPN'

let tncContent = null
let tncTitle = null
let pnTitle = null
let pnContent = null

export const useTermsAndConditions = () => {
  const [loading, setLoading] = React.useState(false)

  const getTermsAndConditions = async () => {
    try {
      setLoading(true)
      const { data } = await getTnCContent()
      const { title, body } = data || {}
      tncTitle = title
      tncContent = body
      setLoading(false)
      return tncContent
    } catch (e) {
      console.log('getTnC Catch', { ...e })
    }
  }

  return {
    loading,
    tncTitle,
    tncContent,
    getTermsAndConditions,
  }
}

export const usePrivacyNotice = () => {
  const [loading, setLoading] = React.useState(false)

  const getPrivacyNotice = async () => {
    try {
      setLoading(true)
      const { data } = await getPNContent()
      const { title, body } = data || {}
      pnTitle = title
      pnContent = body
      setLoading(false)
      return pnContent
    } catch (e) {
      console.log('getPN Catch', { ...e })
    }
  }

  return {
    loading,
    pnTitle,
    pnContent,
    getPrivacyNotice,
  }
}
